import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = { class: "update-package-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dashboard-header" }, [
      _createElementVNode("h2", { class: "title-main" }, "Update Package")
    ], -1)),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      ($setup.openBuilderDrop && $setup.builderPackage && $setup.builderOptions)
        ? (_openBlock(), _createBlock($setup["BuilderDropdown"], {
            key: 0,
            builderPackage: $setup.builderPackage,
            builders: $setup.builderOptions,
            onSelectBuilder: $setup.onSelectBuilder
          }, null, 8, ["builderPackage", "builders"]))
        : _createCommentVNode("", true),
      ($setup.selectedBuilderHouses && $setup.builderPackage && $setup.openHouseTable)
        ? (_openBlock(), _createBlock($setup["HouseTable"], {
            key: 1,
            houses: $setup.selectedBuilderHouses,
            initialSelectedHouseId: $setup.housePackage.houseId,
            onSelectHouse: $setup.onSelectHouse
          }, null, 8, ["houses", "initialSelectedHouseId"]))
        : _createCommentVNode("", true),
      ($setup.facadePackage.facadeId && $setup.housePackage && $setup.openFacadeOptions)
        ? (_openBlock(), _createBlock($setup["FacadeOptions"], {
            key: 2,
            facades: $setup.selectedHouseFacades,
            initialSelectedFacade: $setup.facadePackage.facadeId,
            onSelectFacade: $setup.onSelectFacade
          }, null, 8, ["facades", "initialSelectedFacade"]))
        : _createCommentVNode("", true),
      ($setup.selectedHouseSiteCosts && $setup.housePackage && $setup.selectedHouseFacades && $setup.openAddSiteCosts)
        ? (_openBlock(), _createBlock($setup["AddSiteCosts"], {
            key: 3,
            siteCosts: $setup.selectedHouseSiteCosts,
            onAddSiteCosts: $setup.onAddSiteCosts
          }, null, 8, ["siteCosts"]))
        : _createCommentVNode("", true),
      ($setup.housePackage && $setup.selectedHouseFacades && $setup.openAddSiteCosts)
        ? (_openBlock(), _createBlock($setup["SummaryPackage"], {
            key: 4,
            project: $setup.estateSelected,
            lot: $setup.lotPackage.name,
            landSize: $setup.lotSelectedSize,
            landPrice: $setup.lotPackage.price,
            homeArea: $setup.selectedHouseArea,
            homePrice: $setup.housePackage.price,
            facadePrice: $setup.facadePackage.price,
            siteCosts: $setup.selectedSiteCosts
          }, null, 8, ["project", "lot", "landSize", "landPrice", "homeArea", "homePrice", "facadePrice", "siteCosts"]))
        : _createCommentVNode("", true),
      ($setup.housePackage && $setup.selectedHouseFacades && $setup.openAddSiteCosts)
        ? (_openBlock(), _createBlock($setup["SavedChanges"], {
            key: 5,
            landSize: $setup.lotSelectedSize,
            siteCosts: $setup.selectedSiteCosts,
            builderPackage: $setup.builderPackage,
            housePackage: $setup.housePackage,
            facadePackage: $setup.facadePackage,
            floorplanPackage: $setup.floorplanPackage,
            lotPackage: $setup.lotPackage,
            landowerId: $setup.selectedLandownerId,
            estateId: $setup.selectedEstateId,
            estateTitle: $setup.estateSelected,
            isUpdate: true
          }, null, 8, ["landSize", "siteCosts", "builderPackage", "housePackage", "facadePackage", "floorplanPackage", "lotPackage", "landowerId", "estateId", "estateTitle"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}